import {Component, inject, OnInit, OnDestroy, Input, signal} from '@angular/core';
import {Router, RouterModule, RouterOutlet, NavigationEnd} from '@angular/router';
import {CommonModule} from '@angular/common';
import {AuthService} from '../../../core/services/auth.service';
import {Subscription} from 'rxjs';
import {SidebarService} from './service/sidebar.service';
import {ISidebarItem} from './interfaces/IsidebarItem';
import {InstanceService} from '../../../core/services/instance.service';
import {HasPermissionDirective} from 'src/app/core/directives/HasPermissionDirective';
import {UserService} from 'src/app/core/services/user.service';
import {IEretailFunctions} from 'src/app/core/models/user/eretailProfile';
import { LogEvotService } from 'src/app/core/services/log-evot.service';

@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [RouterModule, CommonModule, HasPermissionDirective],
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
})
export class SidebarComponent implements OnInit, OnDestroy {
  private _authService = inject(AuthService);
  private _router = inject(Router);
  protected auth = inject(AuthService);
  private routerSubscription!: Subscription;
  private _sidebarService = inject(SidebarService);
  private _instance = inject(InstanceService);
  protected _user = inject(UserService);
  protected _evotLog = inject(LogEvotService);
  

  @Input('collapsed')
  isCollapsed = true;
  instanceName!: string;

  menu!: ISidebarItem[];
  userPermissions!: IEretailFunctions[];

  ngOnInit() {
    this.instanceName = this._instance.getCurrentInstance();
    this.getUserPermissions();

    this._sidebarService.getSidebarRoutes().subscribe(
      (routes) => {
        this.menu = this.filterMenuByPermissions(routes);
      },
      (err) => {
        this._evotLog.logError('Erro ao configurar sidebar', err)
      },
    );

    this.routerSubscription = this._router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.closeAllSubmenus();
        this.openActiveSubmenu();
      }
    });
  }

  ngOnDestroy() {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
  }

  expand() {
    this.isCollapsed = !this.isCollapsed;
  }

  getUserPermissions() {
    const localUser = this._user.getLocalUser();
    this.userPermissions = localUser?.perfil?.funcoes!;
    // this._user.getLocalUser().then((x) => {
    //   this.userPermissions = x?.perfil?.funcoes!;
    // });
  }

  logout() {
    this._user.clearUser();
    this._authService.logout();
  }

  isRouteActive(url: string): boolean {
    return this._router.url.includes(url);
  }

  getIconClass(item: any): string {
    return this.isRouteActive(item.url) ? `${item.icon}-fill` : item.icon;
  }

  getActiveClass(item: any): string {
    return this.isRouteActive(item.url) ? `is-active` : '';
  }

  toggleSubmenu(item: any) {
    if (item.subRoutes) {
      item.isOpen = !item.isOpen;
    }
  }

  closeAllSubmenus() {
    this.menu.forEach((item: any) => {
      if (item.subRoutes) {
        item.isOpen = false;
      }
    });
  }

  openActiveSubmenu() {
    this.menu.forEach((item: any) => {
      if (item.subRoutes && this.isRouteActive(item.url)) {
        item.isOpen = true;
      }
    });
  }

  isSubMenuActive(item: any): boolean {
    return item.subRoutes.some((subItem: any) => this.isRouteActive(subItem.url));
  }

  filterMenuByPermissions(menuItens: ISidebarItem[]): ISidebarItem[] {
    return menuItens.filter((item) => {
      if (!item.functions) {
        return true;
      }
      return this.userPermissions.some((permission) => permission.id === item.functions);
    });
  }
}
